import { render, staticRenderFns } from "./exchange-list-filter.vue?vue&type=template&id=945dc4b4&"
import script from "./exchange-list-filter.vue?vue&type=script&lang=js&"
export * from "./exchange-list-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports